import { render, staticRenderFns } from "./ProjectInput.vue?vue&type=template&id=3daababb&"
import script from "./ProjectInput.vue?vue&type=script&lang=js&"
export * from "./ProjectInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports